import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { isMobile } from "react-device-detect";
const Footer = () => {
  const [socialIcon, setSocialIcon] = useState({});

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getSetting, {
      website: hostname,
    });
    if (data?.success) {
      setSocialIcon(data?.results);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return isMobile ? (
    
    <footer
      className="v-footer footer-color v-sheet theme--light"
      data-booted="true"
    >
      <div className="row no-gutters align-center justify-center">
        <div className="col col-12 px-3 py-0">
          <hr
            role="separator"
            aria-orientation="horizontal"
            className="footer-divider v-divider theme--light"
          />
        </div>
        <div className="col col-12 px-3 py-0">
          <div className="row no-gutters">
            <p className="main_title">{t("BrandAmbassadors")}</p>
          </div>
          <div className="row no-gutters">
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/samira_mahi_khan.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Samira Mahi Khan</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/apu_biswas.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Apu Biswas</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-12 px-3 py-1">
          <div className="dotted-line py-3" />
        </div>
        <div className="col col-12 px-3 py-0">
          <div className="row no-gutters">
            <p className="main_title">{t("Sponsorships")}</p>
          </div>
          <div className="row no-gutters">
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/vegas_vikings.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Vegas Vikings</p>
                <p className="year-text">2025/2026</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/sudurpaschim_royals.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Sudurpaschim Royals</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/telugu_warriors.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Telugu Warriors</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/colombo_strikers.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Colombo Strikers</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/grand_cayman_jaguars.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Grand Cayman Jaguars</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/montreal_tigers.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Montreal Tigers</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/dambulla_aurea.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Dambulla Aurea</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/northern_warriors.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Northern Warriors</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-12 px-3 py-1">
          <div className="dotted-line py-3" />
        </div>
        <div className="row no-gutters justify-space-between px-3">
          <div className="py-1 col col-12">
            <div className="row no-gutters">
              <label className="subtitle-1 footer-link-label">
                <p className="main_title">{t("PaymentMethod")}</p>
              </label>
            </div>
            <div className="row d-flex align-center no-gutters">
              <div className="row d-flex align-center no-gutters">
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_bkash_colour.webp"
                    alt="bkash9"
                    className="mr-4 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_nagad_colour.webp"
                    alt="nagad"
                    className="mr-4 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_rocket_colour.webp"
                    alt="rocket"
                    className="mr-4 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_upay_colour.webp"
                    alt="upay"
                    className="mr-4 grayscale-on-hover"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col col-12 px-0 py-1">
            <div className="dotted-line py-3" />
          </div>
          <div className="py-1 col col-12">
            <div className="row no-gutters">
              <p className="main_title">{t("RESPONSIBLEGAMING")}</p>
            </div>
            <div className="row no-gutters">
              <img src="https://babu88.gold/static/svg/btm-18+.svg" alt className="footer-icon" />
              <img
                src="/assets/new/btm-gamcare.webp"
                alt
                className="footer-icon"
              />
            </div>
          </div>
          <div className="col col-12 px-0 py-1">
            <div className="dotted-line py-3" />
          </div>
          <div className="py-0 col col-12">
            <div className="row no-gutters">
              <label className="subtitle-1 footer-link-label">
                <p className="main_title">{t("FollowUs")}</p>
              </label>
            </div>
            <div className="row no-gutters">
              <a
                href="https://www.facebook.com//"
                target="_blank"
              >
                <img
                 src="/assets/new/hover_btm-fb.webp"
                  alt
                  className="footer-icon grayscale-on-hover"
                />
              </a>
              <a href="https://www.youtube.com/@" target="_blank">
                <img
                 src="/assets/new/btm-yt.webp"
                  alt
                  className="footer-icon"
                />
              </a>
              <a
                href="https://www.instagram.com//"
                target="_blank"
              >
                <img
                  src="/assets/new/hover_btm-ig.webp"
                  alt
                  className="footer-icon grayscale-on-hover"
                />
              </a>
              <a href="https://x.com/" target="_blank">
                <img
                  src="/assets/new/btm-twitter.webp"
                  alt
                  className="footer-icon"
                />
              </a>
              <a href="https://t.me/" target="_blank">
                <img
                  src="/assets/new/hover_btm-tlg.webp"
                  alt
                  className="footer-icon grayscale-on-hover"
                />
              </a>
            </div>
          </div>
          <div className="col col-12 px-0 py-1">
            <div className="dotted-line py-3" />
          </div>
          <div className="py-0 col col-12">
            <div className="row no-gutters">
              <a href="#m" target="_blank">
                <img
                  width={180}
                  src="/assets/new/babu88-official.webp"
                  alt
                  className="mr-3 mt-0"
                />
              </a>
            </div>
            <div className="row align main_title no-gutters">
              {t("BangladeshNo1")}
            </div>
            <div className="row align white--text no-gutters">
              {t("Copyright")}
            </div>
          </div>
        </div>
        {/**/}
        {/**/}
        <div className="col col-12 px-3 py-4">
          <div className="dotted-line py-3" />
        </div>
        <div
          className="row py-6 paddingLR second_footer no-gutters"
          style={{ display: "none" }}
        >
          <div className="col col-12">
            <h3 className="main_title pb-2">{t("BangladeshTrusted")}</h3>
            <p className="seo_text">{t("FooterSeoText")}</p>
          </div>
          {/**/}
          {/**/}
          {/**/}
          {/**/}
          <label className="readMore">{t("ReadMore")}</label>
          {/**/}
        </div>
        <div className="px-5 col col-12">
          <div className="row no-gutters justify-space-between">
            <div className="col-lg-4 col-6">
              <div className="row no-gutters">
                <label className="subtitle-1 footer-link-label">
                  {t("ResponsibleGames")}
                </label>
              </div>
              <div className="row no-gutters">
                <img src="https://babu88.gold/static/svg/btm-18+.svg" alt className="footer-icon" />
              </div>
            </div>
            <div className="col-lg-4 col-6">
              <div className="row no-gutters">
                <label className="subtitle-1 footer-link-label">
                  {t("CertifiedBy")}
                </label>
              </div>
              {/**/}
              <div className="row no-gutters">
                <a href="#" target="_blank">
                  <img
                    width="132px"
                    src="/assets/new/babu88-official.webp"
                    alt
                    className="mr-3 mt-1"
                  />
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="row no-gutters">
                <label className="subtitle-1 footer-link-label">
                  {t("FindUs")}
                </label>
              </div>
              <div className="row no-gutters">
                <a
                  href="https://www.facebook.com//"
                  target="_blank"
                >
                  <img
                    src="/assets/new/hover_btm-fb.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                <a
                  href="https://www.instagram.com//"
                  target="_blank"
                >
                  <img
                  src="/assets/new/hover_btm-ig.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                <a href="https://x.com/" target="_blank">
                  <img
                    src="/assets/new/btm-twitter.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                <a href="https://www.youtube.com/" target="_blank">
                  <img
                   src="/assets/new/btm-yt.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                {/* <a href="https://t.me/" target="_blank">
                  <img
                    src="/assets/new/btm-tlg.webp"
                    alt
                    className="footer-icon"
                  />
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="px-5 mt-12 align col col-12 pr-4 py-2">
          {t("Copyright")}
        </div>
      </div>
    </footer>
  ) : (
    <footer
      className="v-footer footer-color v-sheet theme--light"
      data-booted="true"
    >
      <div className="row no-gutters align-center justify-center">
        <div className="col col-12 paddingLR py-1">
          <div className="dotted-line py-3" />
        </div>
        <div className="col col-12 paddingLR py-0">
          <div className="row no-gutters">
            <p className="main_title">{t("BrandAmbassadors")}</p>
          </div>
          <div className="row no-gutters">
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/samira_mahi_khan.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Samira Mahi Khan</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/apu_biswas.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Apu Biswas</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-12 paddingLR py-1">
          <div className="dotted-line py-3" />
        </div>
        <div className="col col-12 paddingLR py-0">
          <div className="row no-gutters">
            <p className="main_title">{t("Sponsorships")}</p>
          </div>
          <div className="row no-gutters">
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/vegas_vikings.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Vegas Vikings</p>
                <p className="year-text">2025/2026</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/sudurpaschim_royals.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Sudurpaschim Royals</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/telugu_warriors.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Telugu Warriors</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/colombo_strikers.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Colombo Strikers</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/grand_cayman_jaguars.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Grand Cayman Jaguars</p>
                <p className="year-text">2024/2025</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/montreal_tigers.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Montreal Tigers</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/dambulla_aurea.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Dambulla Aurea</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
            <div className="d-flex py-1 sponsor-cursor col-md-4 col-lg-2 col-6">
              <img
                width={40}
                height={40}
                src="/assets/new/northern_warriors.webp"
                alt
              />
              <div className="sponsor-border">
                <p className="sponsorship-text">Northern Warriors</p>
                <p className="year-text">2023/2024</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-12 paddingLR py-1">
          <div className="dotted-line py-3" />
        </div>
        {/**/}
        <div className="row no-gutters justify-space-between paddingLR py-0">
          <div className="py-1 col col-6">
            <div className="row no-gutters">
              <label className="subtitle-1 footer-link-label">
                <p className="main_title">{t("PaymentMethod")}</p>
              </label>
            </div>
            <div className="row d-flex align-center no-gutters">
              <div className="row d-flex align-center no-gutters">
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_bkash_colour.webp"
                    alt="bkash9"
                    className="mr-4 mt-2 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_nagad_colour.webp"
                    alt="nagad"
                    className="mr-4 mt-2 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_rocket_colour.webp"
                    alt="rocket"
                    className="mr-4 mt-1 grayscale-on-hover"
                  />
                </a>
                <a>
                  <img
                    width="60px"
                    src="/assets/new/icon_footer_upay_colour.webp"
                    alt="upay"
                    className="mr-4 mt-2 grayscale-on-hover"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="py-1 col col-6">
            <div className="row no-gutters">
              <p className="main_title">{t("RESPONSIBLEGAMING")}</p>
            </div>
            <div className="row no-gutters">
              <img src="https://babu88.gold/static/svg/btm-18+.svg" alt className="footer-icon" />
              <img
                src="/assets/new/btm-gamcare.webp"
                alt
                className="footer-icon"
              />
            </div>
          </div>
        </div>
        <div className="paddingLR py-5 col col-12">
          <div className="dotted-line py-4" />
          <div className="row no-gutters justify-space-between">
            <div className="py-0 col col-6">
              <div className="row no-gutters">
                <a href="https://babu88official.com" target="_blank">
                  <img
                    width={180}
                    src="/assets/new/babu88-official.webp"
                    alt
                    className="mr-3 mt-0"
                  />
                </a>
              </div>
              <div className="row align main_title no-gutters">
                {t("BangladeshNo1")}
              </div>
              <div className="row align white--text no-gutters">
                {t("Copyright")}
              </div>
            </div>
            <div className="py-0 col col-6">
              <div className="row no-gutters">
                <label className="subtitle-1 footer-link-label">
                  <p className="main_title">{t("FollowUs")}</p>
                </label>
              </div>
              <div className="row no-gutters">
                <a
                  href="https://www.facebook.com//"
                  target="_blank"
                >
                  <img
                   src="/assets/new/hover_btm-fb.webp"
                    alt
                    className="footer-icon grayscale-on-hover"
                  />
                </a>
                <a href="https://www.youtube.com/@" target="_blank">
                  <img
                    src="/assets/new/btm-yt.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                >
                  <img
                    src="/assets/new/hover_btm-ig.webp"
                    alt
                    className="footer-icon grayscale-on-hover"
                  />
                </a>
                <a href="https://x.com/" target="_blank">
                  <img
                    src="/assets/new/btm-twitter.webp"
                    alt
                    className="footer-icon"
                  />
                </a>
                <a href="https://t.me/" target="_blank">
                  <img
                    src="/assets/new/hover_btm-tlg.webp"
                    alt
                    className="footer-icon grayscale-on-hover"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="row no-gutters" style={{ display: "none" }}>
            <div className="col-lg-4 col-12" />
          </div>
        </div>
        <div className="col col-12 paddingLR py-1">
          <div className="dotted-line py-3" />
        </div>
        <div className="row py-6 paddingLR second_footer no-gutters">
          <div className="col col-12">
            <h3 className="main_title pb-2">{t("BangladeshTrusted")}</h3>
            <p className="seo_text">{t("FooterSeoText")}</p>
          </div>
          {/**/}
          {/**/}
          {/**/}
          {/**/}
          <label className="readMore">{t("ReadMore")}</label>
          {/**/}
        </div>
        {/**/}
        {/**/}
      </div>
    </footer>
  );
};

export default Footer;
